export default class MarkAllNotificationsAsRead {
  constructor(notificationRepository) {
    this.notificationRepository = notificationRepository;
  }

  async execute(userId) {
    if (!userId) {
      throw new Error('User ID is required');
    }
    return this.notificationRepository.markAllAsRead(userId);
  }
} 